import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ICalendar } from '../interfaces';
import { CalendarsStore } from './calendars.store';

@Injectable({ providedIn: 'root' })
export class CalendarsQuery extends Query<{ data: ICalendar[] }> {
  public calendars$: Observable<ICalendar[]> = this.select((state) => state.data).pipe(
    debounceTime(100),
    map((calendars: ICalendar[]) => {
      return calendars.map((c) => ({
        ...c,
        specified_email: `${c.email} (${capitalize(c.app_name)})`,
      }));
    }),
  );

  constructor(protected override store: CalendarsStore) {
    super(store);
  }
}

export const capitalize = (str: string) =>
  str.toLowerCase().replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());
